import zappy from "@zappy-ride/library.react.components";
import { OutputElectricity } from "./Electricity";

export * from "./Electricity";

zappy.FactoryInstance.registerComponent(OutputElectricity);
